import Routes from "security-app/routing/Routes";
import { CONFIGURATION_NAV_TITLE } from "common/Constants";
export const PAGE_NAV_TITLE = "Investigations";
const investigationsPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    { description: "Open", path: Routes.INVESTIGATIONS.LIST, exactPathMatch: true },
    { description: "Archived", path: Routes.INVESTIGATIONS.ARCHIVED },
    { description: CONFIGURATION_NAV_TITLE, path: Routes.INVESTIGATIONS.CONFIGURATION, permissions: "investigations:edit" }
  ]
};
export default investigationsPageNavigation;
